import {Component, Input} from '@angular/core';


@Component({
    selector: 'ui-title',
    host: {class: 'ui-title'},
    template: `
	    <div class="ui-title-title">
		    {{title}}
		    <ng-content></ng-content>
	    </div>
    `
})
export class UITitleComponent {
    @Input() title;
    @Input() fixed = true;
}
